var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"OptionsGroup btn-group"},_vm._l((_vm.options),function(option){return _c('button',{staticClass:"OptionsGroup-Option btn",class:{ "btn-outline-secondary": option !== _vm.selected, "btn-primary": option === _vm.selected },on:{"click":() => _vm.handleClick(option)}},[_vm._v(_vm._s(_vm.getOptionText(option)))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }